// extracted by mini-css-extract-plugin
var _1 = "iK30P";
export { _1 as "base" }
